import type { ApolloClient } from '@apollo/client'

export const refreshTimeZoneText = (client: ApolloClient): Promise<unknown> => {
  const cache = client.cache

  cache.evict({ broadcast: false, fieldName: 'banners' })
  cache.evict({ broadcast: false, fieldName: 'invoicesFilteringOptions' })

  const snapshot = cache.extract()
  const records = typeof snapshot === 'object' && snapshot !== null ? snapshot : {}

  for (const [id, record] of Object.entries(records)) {
    if (typeof record !== 'object' || record === null || !('__typename' in record)) {
      continue
    }

    if (record.__typename === 'Banner') {
      cache.evict({ broadcast: false, id, fieldName: 'message' })
    } else if (record.__typename === 'SyncEvent') {
      cache.evict({ broadcast: false, id, fieldName: 'displayText' })
      cache.evict({ broadcast: false, id, fieldName: 'displaySubtext' })
    } else if (
      record.__typename === 'QuickBooksState' ||
      record.__typename === 'XeroState' ||
      record.__typename === 'NetsuiteState'
    ) {
      cache.evict({ broadcast: false, id, fieldName: 'syncErrorMessage' })
    }
  }

  return client.refetchQueries({
    include: 'active',
    onQueryUpdated: (query) => {
      const fields = [
        'banners',
        'syncErrorMessage',
        'accountingSyncEvents',
        'displaySubtext',
        'displayText',
        'invoicesFilteringOptions',
      ]
      let localizedText = false

      for (const definition of query.query.definitions) {
        if (definition.kind !== 'OperationDefinition' && definition.kind !== 'FragmentDefinition') {
          continue
        }

        const selections = [...definition.selectionSet.selections]

        while (selections.length) {
          const selection = selections.pop()

          if (selection?.kind === 'Field') {
            localizedText ||= fields.includes(selection.name.value)
            selections.push(...(selection.selectionSet?.selections ?? []))
          } else if (selection?.kind === 'InlineFragment') {
            selections.push(...selection.selectionSet.selections)
          }
        }
      }

      return localizedText
    },
  })
}
